import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import FeatherIcon from "feather-icons-react";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AdminModuleTemplate = ({
  templateModal: { subMenuPermissions },
  templateEvents: { handlePermissionClick },
}) => {
  return (
    <PageWrapperComponent>
      <div className="app-user-list">
        <div className="row">
          <div style={{ fontSize: 18, fontWeight: "bold", marginBottom: 30 }}>
            Admin Module
          </div>
          {subMenuPermissions.map((permission) => (
            <div
              className="col-sm-2 col-lg-2"
              key={permission.id}
              onClick={() => handlePermissionClick(permission)}
            >
              <div className="card">
                <div
                  className="card-body"
                  style={{ textAlign: "center", cursor: "pointer" }}
                >
                  <div className="avatar avatar-stats p-50 m-0 bg-light-primary">
                    <div className="avatar-content">
                      <FontAwesomeIcon icon={"coffee"} />
                    </div>
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <p className="card-text">{permission.menu_name}</p>
                  </div>
                  <div className="d-flex justify-content-between align-items-center"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>{" "}
    </PageWrapperComponent>
  );
};

export default AdminModuleTemplate;
